export const statusBarPlaceholder = "Cbn$3";
export default {statusBarPlaceholder};